import { gql } from '@apollo/client';

export const GET_DASHBOARD_INFO = gql`
  query MyQuery(
    $personId: Int!
    $status: MyActivityPhases!
    $pageSize: Int
    $pageNo: Int
  ) {
    getUserCred(personId: $personId, pageNo: $pageNo, pageSize: $pageSize) {
      totalCount
      history {
        action
        date
        tracker
        weight
      }
      metricInfo {
        name
        score
      }
    }
    getUserProfile {
      history {
        applications
        chatterBoxTrials
        houseParty
        memberSince
      }
      credScore
      profile {
        personId
        person {
          headshot
          firstName
          lastName
        }
      }
    }
    getMyActivity(status: $status) {
      agId
      sd
      ed
      apSd
      apEd
      exSd
      exEd
      category
      store
      status
      errMsg
      opt
      alwaysOpen
      async
      startsOn
      endsOn
      eid
      ename
      sid
      sname
      aid
      aname
      awgt
    }
  }
`;
